import * as React from 'react'
import moment from 'moment'
import 'moment/locale/ja'
import { SingleDatePicker } from 'react-dates'
import styled, { createGlobalStyle } from 'styled-components'
import * as constants from 'static/constants'

interface IProps {
  date: string | undefined
  onChange: (date: string) => void
}

const DATE_FORMAT = 'YYYY-MM-DD'

const OtaReservationDatePicker: React.FC<IProps> = ({ date, onChange }) => {
  const [focused, setFocused] = React.useState(false)
  const parsedDate = moment(date, DATE_FORMAT, true)
  const selectedDate = parsedDate.isValid() ? parsedDate : null
  const calendarDate = selectedDate || moment()

  const handleDateChange = React.useCallback(
    (nextDate: moment.Moment | null) => {
      if (!nextDate) {
        return
      }

      onChange(nextDate.format(DATE_FORMAT))
      setFocused(false)
    },
    [onChange]
  )

  const handleTodayClick = React.useCallback(() => {
    onChange(moment().format(DATE_FORMAT))
    setFocused(false)
  }, [onChange])

  return (
    <Wrapper className="OtaReservationDatePicker">
      <CalendarSelectCustomStyle />
      <button type="button" className="button today" onClick={handleTodayClick}>
        今日
      </button>
      <button
        type="button"
        className="button date"
        onClick={() => setFocused(true)}
        aria-label="日付を選択"
      >
        {selectedDate ? selectedDate.format(DATE_FORMAT) : '全日付'}
      </button>
      <SingleDatePicker
        date={calendarDate}
        onDateChange={handleDateChange}
        focused={focused}
        onFocusChange={changed => setFocused(changed.focused)}
        numberOfMonths={1}
        displayFormat={DATE_FORMAT}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel={true}
        noBorder={true}
        block={false}
        small={true}
        readOnly={true}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .button {
    height: 40px;
    padding: 0 16px;
    border: solid 1px ${constants.COLORS.divider};
    background: ${constants.COLORS.white};
    color: ${constants.COLORS.black};
    font-size: 14px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.6;
    }

    &.today {
      border-radius: 8px 0 0 8px;
      border-right: none;
      white-space: nowrap;
    }

    &.date {
      min-width: 142px;
      border-radius: 0 8px 8px 0;
    }
  }
`

const CalendarSelectCustomStyle = createGlobalStyle`
  .OtaReservationDatePicker .SingleDatePicker {
    z-index: 2;
    position: absolute;
    top: -10px;
    right: 0;
    left: 0;
    margin: 0 auto;
    pointer-events: none;
  }

  .OtaReservationDatePicker .SingleDatePicker_picker {
    pointer-events: auto;
  }

  .OtaReservationDatePicker .DateInput_input,
  .OtaReservationDatePicker .DateInput__small {
    display: none;
    opacity: 0;
    pointer-events: none;
  }
`

export default OtaReservationDatePicker
